import RequestHandler from "../RequestHandler";
import {ProductState} from "../../features/Products/interfaces/ProductComponentState";
import {get, keyBy} from "lodash";
import ProductPaginationResponse from "../../features/Products/interfaces/ProductListResponse";
import {ServiceInterface} from "../../interfaces/ServiceInterface";
import CategoryResponse from "../../features/Categories/interfaces/CategoryResponse";
import AppSettingController from "../../features/Main/controller/AppSettingController";
import marketSettingLocalStorage from "../../features/Main/interface/MarketSettingLocalStorage";
import CheckResponse from "../../features/Invoice/interface/checkResponse";
import PriceInterface from "../../features/Invoice/interface/priceInterface";
import OrderResponse from "../../features/Invoice/interface/orderResponse";
import moment from "jalali-moment";

export default class HamiService implements ServiceInterface {
    url: string = ''

    constructor() {
        const setting = AppSettingController.getSetting() as marketSettingLocalStorage;
        this.url = get(setting, "baseUrl", "")
    }

    async getProducts(shopId: string, categoryId: string): Promise<ProductPaginationResponse> {
        const res = await RequestHandler.get(`GetGoods.aspx`);
        const branchStock = await RequestHandler.get(`GetGoodsBranchStock.aspx`);
        const stockById = keyBy(branchStock.Quantity, "GoodsId");

        let data: ProductState[] = get(res, "Goods", []).map((item: any) => {
            const stock = stockById[item.GoodsId] || {};

            return {
                _id: item.GoodsId,
                title: item.GoodsName,
                price: item.GoodsPrice,
                category_id: item.GoodsGroupId,
                description: item.GoodsDescription,
                updated_at: item.LastModificationDate,
                lastSalePrice: stock.LastSalePrice ?? 0,
                quantity: stock.Quantity ?? 0,
                image: this.url + `/product/${item.GoodsCode}.png`,
                status: true,
                limit_add_to_cart: stock.Quantity ?? 0,
                total: stock.Quantity ?? 0,
                final_total: stock.Quantity ?? 0,
                minimumAmount: stock.Quantity ?? 0,
            };
        });

        if (categoryId) {
            data = data.filter(item => item.category_id === categoryId.toString());
        }

        return {
            status: true,
            data: {
                current_page: 1,
                data,
                first_page_url: "",
                from: 1,
                last_page: 1,
                last_page_url: "",
                links: [],
                next_page_url: null,
                path: "",
                per_page: 10,
                prev_page_url: null,
                to: data.length,
                total: data.length
            }
        };
    }

    async categories(): Promise<CategoryResponse> {
        const categories = await RequestHandler.get(`GetGoodsGroup.aspx`)
        return {
            status: true,
            data: {
                data: categories.GoodsGroup.map((category: any) => ({
                    _id: category.GroupId,
                    name: category.GroupName,
                }))
            }
        }
    }

    async checkOrders(items: {
        id: string,
        name: string,
        count: string,
        price: string
    }[]): Promise<CheckResponse> {
        const res = await RequestHandler.get(`GetGoodsBranchStock.aspx`)
        const quantityList = res.Quantity

        const result = []

        for (const item of items) {
            const goods = quantityList.find((q: any) => q.GoodsId === +item.id)
            const can = goods ? goods.Quantity >= +item.count : false

            result.push({
                can,
                count: +item.count,
                id: item.id,
                name: item.name,
                price: +item.price,
            })
        }

        const status = result.every(r => r.can)

        return {data: result, status}
    }

    setOrder(shopId: string, price: PriceInterface, order: {
        products: {
            count: number,
            id: string,
            name: string,
            price: string,
        }[],
        payAt: string,
        rrn?: string,
        trace?: string,
    }, desk?: string): Promise<OrderResponse> {
        const orderId = Math.floor(Math.random() * 200)
        const now = moment();
        const date = now.locale('fa').format('YYYY/MM/DD');
        const time = now.format('HH:mm:ss');

        return RequestHandler.post(`SetInvoice.aspx`, {
            Invoice: {
                OrderId: orderId,
                BranchId: 0,
                FirstName: "سفارش",
                LastName: "کیوسک",
                OrderDate: date,
                OrderTime: time,
                CellPhone: "",
                LocationId: 0,
                DeliveryAddress: "",
                Comments: "",
                OrderType: 1,
                Price: get(price, "regular", ""),
                DeliveryPrice: 0,
                PackingPrice: 0,
                Discount: 0,
                Tax: 0,
                Duty: 0,
                Addition: 0,
                Rounded: 0,
                Payable: 0,
                Remaining: 0,
                CommissionPrice: 0,
                PaymentTypeId: 1,
                Items: order.products.map((product, index) => ({
                    OrderItemId: Math.floor(Math.random() * 200) + index,
                    OrderId: orderId,
                    ProductId: product.id,
                    ProductCode: 0,
                    ProductTitle: product.name,
                    DescriptionPrice: 0,
                    Description: "",
                    ProductDiscount: 0,
                    Addition: 0,
                    ProductTax: 0,
                    ProductDuty: 0,
                    Quantity: product.count,
                    TotalPrice: +product.price * product.count,
                    SumPrice: +product.price * product.count,
                    ProductPrice: +product.price * product.count,
                })),
                ItemsTopping: []
            }
        }, {'Content-Type': 'application/json'})
    }

    getBaseUrl() {
        return this.url
    }
}
